<template>
  <div class="centered-image" :class="{'row-40-25': props.data.isLarger, 'row-250-40': !props.data.isLarger}">
    <!-- Video -->
    <WidgetVideo
      v-if="props.data.videoUrl"
      class="is-cover"
      :videoUrl="props.data.videoUrl"
      :controls="false"
      :loop="true"
      :autoplay="true"
      :forcePlay="true"
      :muted="true"
    />
    <WidgetPicture
      v-else-if="props.data.image?.responsiveImage"
      class="is-cover"
      :image="{ custom: props.data.image?.responsiveImage }"
      :lazyLoad="true"
      :alt="props.data.image?.responsiveImage?.alt"
    />
  </div>
</template>

<script>
export default {
  name: 'PagesCommonCenteredImage',
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
